import extendNode from '../extendNode.mjs'
import useCategoryNode from '../_CATEGORY/useCategoryNode.jsx'
import meta from './metaUiParam.mjs'

export default () => {
    const CategoryNode = useCategoryNode()

    return extendNode(CategoryNode, {
        ...meta,

        _getCategories(map, node) {
            return [
                'UI_INPUT',
                'UI_OUTPUT',
                'UI_VARIABLE',
            ]
        },
    })
}
